var PTConfigManager = /** @class */ (function () {
    function PTConfigManager() {
        this.ptConfig = {};
        this.prometheusDbPrefix = "pt_";
        try {
            this.ptConfig = JSON.parse(localStorage.getItem("ptConfig"));
            if (this.ptConfig == null) {
                this.ptConfig = {};
                localStorage.setItem("ptConfig", JSON.stringify({}));
            }
        }
        catch (e) {
            this.ptConfig;
            localStorage.setItem("ptConfig", JSON.stringify({}));
            console.warn(e);
        }
    }
    PTConfigManager.prototype._save = function () {
        localStorage.setItem("ptConfig", JSON.stringify(this.ptConfig));
    };
    PTConfigManager.prototype.set = function (ind, data) {
        this.ptConfig[ind] = data;
        this._save();
    };
    PTConfigManager.prototype.get = function (ind) {
        return this.ptConfig[ind];
    };
    PTConfigManager.prototype.remove = function (ind) {
        delete this.ptConfig[ind];
        this._save();
    };
    return PTConfigManager;
}());
var Greeter = /** @class */ (function () {
    function Greeter(message) {
        this.greeting = message;
    }
    Greeter.prototype.greet = function () {
        return "Hello, " + this.greeting;
    };
    return Greeter;
}());
var greeter = new Greeter("world");
